import styled from 'styled-components';

export const HeaderTab = styled.div`
  @media (min-width: 1200px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .slick-slide {
    @media (min-width: 1000px) {
      width: 226px !important;
    }
  }
  .slick-track {
    .slick-slide {
      &:first-child {
        border-left: 1px solid #dcdcdc;
      }
    }
  }
  .slick-prev {
    left: 0px;
    z-index: 9;
  }
  .slick-next {
    right: 0px;
  }
`;
export const TabWrapper = styled.div`
  position: relative;
  margin: 2rem 30px 0;
  @media (min-width: 991px) {
    &[dir='rtl'] {
      .slick-track {
        .slick-slide {
          float: right !important;
        }
      }
    }
  }
  @media (min-width: 768px) {
    &[dir='ltr'] {
      .slick-track {
        .slick-slide {
          margin-left: -1px;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
    &[dir='rtl'] {
      .slick-track {
        .slick-slide {
          margin-right: -1px;
        }
      }
    }
  }
  .slick-track {
    .slick-slide {
      border: 1px solid #dcdcdc;
      border-bottom: 0px;
      button {
        border: 0;
      }
      @media (max-width: 767.98px) {
      }
    }
  }
  &.whatwedotab_wrapper {
    .slick-slide {
      @media (max-width: 767.98px) {
        border: transparent;
      }
    }
  }
  &[dir='ltr'],
  &[dir='rtl'] {
    .slick-prev {
      z-index: 9;
      @media (max-width: 767.98px) {
        left: -55px;
        &:before {
          transform: rotate(135deg);
        }
      }
    }
    .slick-next {
      @media (max-width: 767.98px) {
        right: -55px;
        &:before {
          transform: rotate(-45deg);
        }
      }
    }
  }
  &.tab_pddn_wrapper {
    @media (min-width: 768px) and (max-width: 1200px) {
      margin: 2rem 29px 0;
    }
  }
  &.accommodation_tab {
    .slick-slide {
      @media (min-width: 1200px) {
        float: ${({ dir }) => (dir === 'rtl' ? 'right!important' : '')};
      }
      .tabs {
        img {
          height: 45px;
          width: auto;
        }
      }
    }
  }
  &.transport_tab,
  &.facilities_tab {
    .slick-slide {
      @media (min-width: 768px) {
        float: ${({ dir }) => (dir === 'rtl' ? 'right!important' : '')};
      }
    }
  }
  &.trip_planner_tab {
    .slick-slide {
      @media (min-width: 768px) {
        float: ${({ dir }) => (dir === 'rtl' ? 'right!important' : '')};
      }
    }
  }
`;
export const HeaderTabAwards = styled.div`
  margin: 2rem 30px 0;
  @media (min-width: 992px) and (max-width: 1400px) {
    margin: 2rem 29px 0;
  }
  @media (min-width: 768px) and (max-width: 992px) {
    margin: 2rem 37px 0;
  }
  .slick-dots {
    display: none !important;
  }
  &[dir='ltr'] {
    .tabs {
      margin-left: -1px;
    }
    .slick-prev {
      @media (max-width: 900px) {
        left: -35px;
      }
      @media (max-width: 768px) {
        left: -40px;
        z-index: 999;
      }
    }
    .slick-next {
      @media (max-width: 900px) {
        right: -35px;
      }
      @media (max-width: 768px) {
        right: -40px;
        z-index: 999;
      }
    }
    .slick-slide {
      &:first-child {
        border-left: 1px solid #ebebeb !important;
      }
    }
  }

  &[dir='rtl'] {
    .tabs {
      @media (min-width: 768px) {
        margin-right: -1px;
      }
    }

    div[dir='ltr'] {
      .slick-prev {
        left: -50px;
        right: auto;
        z-index: 999;
        @media (max-width: 900px) {
          left: -35px;
        }
        @media (max-width: 767px) {
          left: -40px;
        }
      }
      .slick-next {
        right: -50px;
        left: auto;
        z-index: 999;
        @media (max-width: 900px) {
          right: -35px;
        }
        @media (max-width: 768px) {
          right: -40px;
        }
      }
    }
  }
  &[dir='rtl'] {
    .slick-slider {
      .slick-slide {
        float: right;
      }
      /* .slick-next {
        left: -50px !important;
        right: inherit !important;
        &:before {
          transform: rotate(135deg) !important;
        }
      }
      .slick-prev {
        right: -50px !important;
        left: inherit !important;
        &:before {
          transform: rotate(-45deg) !important;
        }
      } */
    }
  }
  &.awards_headertab {
    .active-tabs {
      @media (max-width: 767.98px) {
        border: 1px solid #f7f7f7;
      }
    }

    .slick-current {
      .active-tabs {
        margin-left: 0px;
      }
    }
  }
`;
export const ButtonTab = styled.button`
  cursor: pointer;
  box-sizing: content-box;
  outline: none;
  font-size: 12px;
  line-height: 1.3;
  height: 121px;
  display: flex !important;
  flex-flow: column;
  justify-content: center;
  width: 190px;
  border-radius: 0;
  border-bottom: 0;
  align-items: center;
  color: #333;
  text-transform: uppercase;
  position: relative;
  border: 1px solid #dcdcdc;
  background: #fff;
  border-bottom: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
  @media (min-width: 768px) {
    border-right: 1px solid #dcdcdc;
  }
  .uberCareem {
    width: 45px;
  }
  svg {
    height: 45px;
    object-fit: contain;
    fill: #333;
  }
  @media (max-width: 767.98px) {
    padding: 5px;
    height: 100px;
    border-left: 1px solid #dcdcdc;
  }
  &:after {
    content: '';
    position: absolute;
    bottom: 15px;
    left: 0;
    right: 0;
    display: inline-block;
    border: solid transparent;
    border-width: 0 1px 1px 0;
    padding: 3px;
    width: 3px;
    height: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    margin: 0 auto;
    transition: 0.8s;
    @media (max-width: 768px) {
      bottom: 5px;
    }
  }
  &.active-tabs:after {
    border-color: #1b7bdd;
  }
  &:hover {
    color: #1b7bdd;
    background-color: #f7f7f7;
    border-left-color: #dcdcdc;
    border-right-color: #dcdcdc;
    border-top-color: #f7f7f7;
    @media (max-width: 767px) {
      border-right-color: #dcdcdc;
    }
  }
  &:hover svg g {
    fill: #1b7bdd;
    &#careem > * {
      fill: #28bb4e !important;
    }
  }
  &:hover:after {
    border-color: #1b7bdd;
  }
  &:not(:first-child) {
    border-left: 1px solid #ebebeb;
  }
  &:not(:last-child) {
    border-right: transparent;
  }
  &hover:not(:last-child) {
    border-right-color: #f7f7f7;
  }
  &.active-tabs {
    background: #f7f7f7;
    color: #1b7bdd;
    border-top-color: #f7f7f7;
  }
  &.active-tabs svg g {
    fill: #1b7bdd;
    &#careem > * {
      fill: #28bb4e !important;
    }
  }
  &.span {
    padding-top: 20px;
  }
  &.acc_tab {
    .lazy-load-image-background {
      display: flex !important;
      justify-content: center;
      align-items: center;
    }
  }
`;
export const TabDescription = styled.div`
  flex-grow: 1;
  background: #f7f7f7;
  padding: 4rem 0 6rem 0;
  overflow: hidden;
  @media (max-width: 767.98px) {
    padding: 2rem 0;
  }
  &.tabgroup_descp {
    @media (max-width: 767.98px) {
      padding: 3rem 0;
    }
    .article_h3 {
      font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif' : '')};
    }
    .threecolumnh3 {
      font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif' : '')};
      @media (max-width: 1199.98px) {
        font-size: 18px;
      }
      @media (max-width: 991.98px) {
        margin-bottom: 1.5rem;
      }
      @media (max-width: 767.98px) {
        font-size: 16px;
      }
    }
    .article-column {
      p {
        @media (max-width: 767.98px) {
          background-color: #f7f7f7;
        }
      }
    }
  }
  &.padnbtn_tabdesc {
    padding: 4rem 0;
    @media (max-width: 767.98px) {
      padding: 3rem 0;
    }
  }
  &.what_we_dodescription {
    padding: 4rem 0;
    @media (max-width: 767.98px) {
      padding: 3rem 0;
    }
    .innercontent_tab {
      h3 {
        font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif ' : '')};
        @media (min-width: 768px) {
          font-size: ${({ dir }) => (dir === 'rtl' ? '20px' : '')};
          line-height: ${({ dir }) => (dir === 'rtl' ? '30px!important' : '')};
        }
        @media (max-width: 767.98px) {
          font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '')};
        }
      }
    }
  }
  .contentblock_tab {
    padding: 0;
    background: none;
  }
  .innercontent_tab {
    width: 100%;
    padding: 0px;
  }
  &.tabgroup {
    .articlecontent {
      padding: 0 0 3rem;
    }
    .slider_img_wrapper {
      overflow: visible;
    }
  }
  &.facilities_tabdescription {
    padding: 50px 0;
    .card-logo {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-bottom: 0;
      .lazy-load-image-background {
        display: block !important;
        height: 100%;
        width: 100% !important;
      }
      @media (min-width: 768px) {
        width: 250px;
        height: 143px;
      }
      @media (min-width: 992px) {
        width: 350px;
        height: 200px;
      }
    }
    .card-brand {
      padding: 0 15px;
      h3 {
        margin-bottom: 0;
        @media (max-width: 1199.98px) {
          font-size: 18px;
        }
        @media (max-width: 767.98px) {
          font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
        }
      }
      @media (min-width: 576px) {
        flex: 0 0 50%;
        max-width: 50%;
      }
      .card-wrapper {
        min-height: 433px;
        @media (min-width: 992px) {
          min-height: 250px !important;
          height: auto !important;
        }
      }
    }
  }
  &.awards_tab_description {
    .article-column {
      p {
        background-color: #f7f7f7;
      }
    }
  }
`;
export const TabImage = styled.img`
  height: 45px;
  object-fit: contain;
`;
export const DescriptionSection = styled.div`
  width: 100%;
  height: 100%;
  display: none;
  div[class*='ThreeColumnIntroBlockstyled__ThreeColumnIntroBlockSection-'] {
    padding: 0;
  }
  &.active-content {
    display: block;
  }
`;
export const Spanpt = styled.span`
  padding-top: 10px;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif' : 'DINRegular')};
`;
export const ArticlePart = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 0 3rem;
  @media (max-width: 992px) {
    display: block;
  }
`;
export const ArticleH3 = styled.h3`
  width: 30%;
  &[dir='rtl'] {
    font-family: GEAwtarDWTCMedium, sans-serif;
  }
  @media (max-width: 992px) {
    width: 100%;
  }
`;
export const ArticleParagraph = styled.div`
  width: 66%;
  -webkit-column-count: 2;
  -moz-column-count: 2;
  column-count: 2;
  -webkit-column-gap: 50px;
  -moz-column-gap: 50px;
  column-gap: 50px;
  p {
    margin-bottom: 1.5rem;
  }
  @media (max-width: 992px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    webkit-column-count: 1;
    -moz-column-count: 1;
    column-count: 1;
  }
`;
export const PdfButton = styled.div`
  font-size: 12px;
  letter-spacing: 1.29px;
  line-height: 16px;
  text-transform: uppercase;
  color: #000;
  display: flex;
  align-items: center;
`;
export const PdfText = styled.div`
  width: 240px;
  a {
    color: #1b7bdd;
    text-decoration: underline;
    padding-left: 10px;
  }
`;
export const ContentBox = styled.div`
  position: relative;
  background: #ebebeb;
  padding: 2rem 2rem 5rem;
  width: 48%;
  margin: 1%;
  &:nth-of-type(even) {
    @media (max-width: 991.98px) {
      background: #f1f1f1;
    }
  }
  @media (min-width: 992px) {
    &:nth-child(4n + 1),
    &:nth-child(4n + 4) {
      background: #f1f1f1;
    }
  }
  @media (max-width: 991.98px) {
    width: 100%;
  }
  h3 {
    @media (max-width: 1199.98px) {
      font-size: 18px;
    }
    @media (max-width: 767.98px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
    }
    &[dir='rtl'] {
      font-family: GESSTwoDWTCMedium, sans-serif;
    }
  }
  p {
    margin-bottom: 1.5rem;
  }
`;
export const TripButtonDiv = styled.div`
  position: absolute;
  bottom: 2rem;
  z-index: 1;
  &[dir='ltr'] {
    left: 2rem;
  }
  &[dir='rtl'] {
    right: 2rem;
  }
  @media (max-width: 767.98px) {
    text-align: center;
    left: 0 !important;
    right: 0px !important;
  }
`;
